<template>
<div id="device-stadistics-view">
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-button :to="`/doors/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="vx-col w-full mb-base">
      <vs-tabs>
        <vs-tab :label="$t('Labels.State')" icon-pack="feather" icon="icon-list" @click="getResponse()">
          <vx-card
              title="Últimas Lecturas">
                  <div style="width: 100%">
                    <a v-if="urlDownload.length > 0" class="btn-primary float-left" :href="urlDownload" download="LogEstado.csv"><feather-icon icon="DownloadCloudIcon" /></a>
                    <select class="vs-vs-inputx vs-input--input mb-3" v-model="log_limit" style="float: right; width: 90px;" @change="getResponse()">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                <vs-table v-if="response" ref="table" :data="response">
                <template slot-scope="{data}">
                  <tbody>
                    <tr class="tr-values vs-table--tr tr-table-state-null selected" :key="indextr" v-for="(tr, indextr) in data" >
                      <listItem
                        :value="tr.created_at"
                        :description="$t('Labels.Date')"
                        img="fecha"
                      ></listItem>
                      <listItem
                        :value="tr.created_at"
                        :description="$t('Labels.LastUpdated')"
                        img="clock"
                        :relativeTime="true"
                      ></listItem>
                      <vs-td>
                        <div class="device-info">
                          <div class="shadow-drop d-theme-dark-bg cursor-pointer round">
                            <img src="@/assets/images/icons/doors_gray.svg" class="info-icon p-2 block" v-if="tr.status === 0 "/>
                            <img src="@/assets/images/icons/doors_red.svg" class="info-icon p-2 block" v-if="tr.status === 1 || tr.status === '2' "/>
                          </div>
                          <div class="device-text-container">
                            <span class="main-info" v-if="tr.status === 0 ">{{$t('Labels.Close')}}</span>
                            <span class="main-info" v-if="tr.status === 1 ">{{$t('Labels.Open')}}</span>
                            <span class="main-info" v-if="tr.status === 2 ">{{$t('Labels.LongOpen')}}</span>
                            <span class="subtext-info">Estado</span>
                          </div>
                        </div>
                      </vs-td>
                    </tr>
                  </tbody>
                </template>
              </vs-table>

          </vx-card>
        </vs-tab>
        <vs-tab :label="$t('Labels.Graphics')" icon-pack="feather" icon="icon-activity" @click="getDayStatictics()">
          <div class="flex">
            <div class="flex-1 p-4">
              <vx-card  :title="$tc('Labels.StatisticDoor')">
                <apexchart v-if="loaded" type="donut" height="350" :options="options" :series="series"></apexchart>
                <div v-else>{{$t('Messages.NoData')}}</div>
              </vx-card>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>

  </div>

</div>
</template>

<script>
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import apexchart from 'vue-apexcharts'
import { empty } from '@/helpers.js'

export default {
  components: {
    listItem,
    apexchart
  },
  data () {
    return {
      response: [],
      log_limit: '5',
      uuid: this.$route.params.uuid,
      urlDownload: '',
      options: {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          type: 'donut',
          height: 350
        },
        dataLabels: {
          enabled: false
        },
        labels: [this.$t('Labels.Close'), this.$t('Labels.Open'), this.$t('Labels.LongOpen')],
        fill: {
          opacity: 1
        }
      },
      series: [],
      loaded: false
    }
  },
  methods: {
    async getResponse () {
      this.$vs.loading()
      const params = {
        url: `modelo/doors/${this.uuid}/log`,
        method: 'GET',
        params: {
          limit: this.log_limit
        }
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.$vs.loading.close()
        this.createCsv()
      })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Date'))
      headers.push(this.$t('Labels.LastSeen'))
      headers.push(this.$t('Labels.Status'))
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.created_at)
        row.push(this.relativeTimeConvert(item.created_at))
        if (item.status === 0) row.push('Cerrada')
        else if (item.status === 1) row.push('Abierta')
        else row.push('Abierta Prolongada')
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    },
    async getDayStatictics () {
      this.$vs.loading()

      const params = {
        url: `modelo/doors/${this.uuid}/stadistics_24`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.series = []
        if (!empty(response.data.data)) {
          if (response.data.data[0] !== undefined) this.series.push(parseInt(response.data.data[0].total))
          if (response.data.data[1] !== undefined) this.series.push(parseInt(response.data.data[1].total))
          if (response.data.data[2] !== undefined) this.series.push(parseInt(response.data.data[2].total))
          this.loaded = true
        } else { this.loaded = false }
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    }
  },
  created () {
    this.getResponse()
  }

}
</script>
